// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import TextField from 'material-ui/TextField';

import TitledCard from 'common/components/cards/TitledCard';
import { Label } from '../styles';
import type { RadioInformationFormSection, CurrentStreamAndEquipmentData } from '../../domain/RadioInformationForm';

type Props = {
  onChange: (value: RadioInformationFormSection) => void,
  data: CurrentStreamAndEquipmentData,
  t: any,
}

function ActualStream(props: Props) {
  return (
    <TitledCard title={props.t('currentStreamAndEquipment')}>
      <div className="row">
        <div className="col-xs-8">
          <Label>{props.t('currentStreamURL')}</Label>
          <TextField
            name="currentStreamURL"
            onChange={(e, v) => props.onChange({ ...props.data, currentStreamURL: v })}
            value={props.data.currentStreamURL}
            fullWidth
          />
        </div>
        <div className="col-xs-8">
          <Label>{'BITRATE'}</Label>
          <TextField
            name="bitrate"
            onChange={(e, v) => props.onChange({ ...props.data, bitrate: v })}
            value={props.data.bitrate}
            fullWidth
          />
        </div>
        <div className="col-xs-8">
          <Label>{props.t('averageSimultaneousUsers')}</Label>
          <TextField
            name="averageSimultaneousUsers"
            onChange={(e, v) => props.onChange({ ...props.data, averageSimultaneousUsers: v })}
            value={props.data.averageSimultaneousUsers}
            fullWidth
          />
        </div>
      </div>
    </TitledCard>
  );
}

export default translate('radioConfiguration')(ActualStream);



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/components/streamConfigurationForm/ActualStream.js